import { ProprietaMisurataDto } from "@/api";
import typography from "@/theme/base/typography";
import { getProprietaMisurataHelper } from "@/utils/proprietaMisurataUtils";
import { ChartData, ChartDataset, ChartOptions } from "chart.js";

function configs(
  datasets: ChartDataset<"line", { x: string; y: number | null }[]>[],
  proprietaMisurate: ProprietaMisurataDto[]
): {
  data: ChartData<"line">;
  options: ChartOptions<"line">;
} {
  const yAxes: ChartOptions<"line">["scales"] = {};

  for (const p of proprietaMisurate) {
    const helper = getProprietaMisurataHelper(p.type);
    if (helper) {
      const unit = helper.unit ?? "scalar";
      const axis = yAxes[unit];
      if (axis) {
        if ("suggestedMin" in axis && typeof axis.suggestedMin === "number") {
          axis.suggestedMin = Math.min(axis.suggestedMin, helper.suggestedMin);
        }
        if ("suggestedMax" in axis && typeof axis.suggestedMax === "number") {
          axis.suggestedMax = Math.max(axis.suggestedMax, helper.suggestedMax);
        }
      } else {
        yAxes[unit] = {
          position: Object.keys(yAxes).length === 0 ? "left" : "right",
          suggestedMin: helper.suggestedMin,
          suggestedMax: helper.suggestedMax,
          border: {
            display: false,
            dash: [5, 5],
          },
          grid: {
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
          },
          ticks: {
            display: true,
            padding: 10,
            // color: "#b2b9bf",
            font: {
              size: 11,
              family: typography.fontFamily,
              style: "normal",
              lineHeight: 2,
            },
            callback: (value) => {
              if (typeof value === "number") {
                return helper.format(value);
              } else {
                return value;
              }
            },
          },
        };
      }
    }
  }

  const config: {
    data: ChartData<"line">;
    options: ChartOptions<"line">;
  } = {
    data: {
      // labels,
      datasets: [...datasets] as any,
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
        },
        colors: {
          forceOverride: datasets.length > 1,
        },
      },
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        ...yAxes,
        x: {
          border: {
            display: false,
            dash: [5, 5],
          },
          grid: {
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: true,
            color: "#b2b9bf",
            padding: 20,
            font: {
              size: 11,
              family: typography.fontFamily,
              style: "normal",
              lineHeight: 2,
            },
          },
        },
      },
    },
  };

  return config;
}

export default configs;
